export const ARTICLE_DISCLAIMER_HTML = `<section class="pea-blog-section pea-notice">
            <p class="pea-paragraph"><strong>Disclaimer</strong>: We are not financial advisers. The information on this website is general in nature and does not take into account your individual circumstances. You should seek independent professional advice before making financial decisions.</p>
        </section>`;

export default function ArticleDisclaimer() {
  return (
    <section className="pea-notice">
      <p>
        <strong>Disclaimer</strong>: We are not financial advisers. The information on this website
        is general in nature and does not take into account your individual circumstances. You
        should seek independent professional advice before making financial decisions.
      </p>
    </section>
  );
}
